import axios from "@/libs/api.request";
// 获取列表
export const getHwBill = data => {
  return axios.request({
    url: "/finance/overseas/bill/list",
    method: "post",
    data
  });
};
export const getDetails = data => {
  return axios.request({
    url: `/finance/overseas/bill/read/${data.id}`,
    method: "post",
    data
  });
};

export const exportDetails = id => {
  return axios.request({
    url: `/finance/overseas/bill/exportDetail/${id}`,
    method: "post"
  });
};

export const resetHwAmount = id => {
  return axios.request({
    url: `/finance/overseas/bill/resetAmount/${id}`,
    method: "post"
  });
};

export const getHwBillClient = params => {
  return axios.request({
    url: `/finance/overseas/bill/query`,
    method: "get",
    params
  });
};

export const saveHwBill = data => {
  return axios.request({
    url: `/finance/overseas/bill/save`,
    method: "post",
    data
  });
};

export const delHwBill = id => {
  return axios.request({
    url: `/finance/overseas/bill/del/${id}`,
    method: "delete"
  });
};

export const updateHwBill = data => {
  return axios.request({
    url: `/finance/overseas/bill/update/${data.id}`,
    method: "post",
    data
  });
};

export const confirmBill = id => {
  return axios.request({
    url: `/finance/overseas/bill/confirm/${id}`,
    method: "post"
  });
};

export const auditBill = data => {
  return axios.request({
    url: `/finance/overseas/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/overseas/bill/append/${data.id}`,
    method: "post",
    data
  });
};

export const getBillClients = id => {
  return axios.request({
    url: `/finance/overseas/bill/clients/${id}`,
    method: "get"
  });
};
export const exportAllBill = data => {
  return axios.request({
    url: `/finance/bill_analyze/hw_bill/export`,
    method: "post",
    data
  });
};

export const hangBill = data => {
  return axios.request({
    url: `/finance/overseas/bill/removeOut/${data.id}`,
    method: "post",
    data
  });
};

export const deleteDetails = data => {
  return axios.request({
    url: `/finance/overseas/bill/deleteDetail/${data.id}`,
    method: "post",
    data
  });
};

export const hwDoHedge = data => {
  return axios.request({
    url: `/finance/hedge/hwDoHedge`,
    method: "post",
    data
  });
};
